import type {
  BookingStop,
  JobBookingCustomer,
} from '@/models/advancedJobBooking';
import type { PacJobBookApiBody, PacProduct } from '@/models/pacJobBooking';

import {
  isRecord,
  parseDraftCustomer,
  parseDraftStopBase,
} from '@/helpers/advancedJobBooking';
import { createEmptyPacProduct } from '@/models/pacJobBooking';

type DraftContent = Partial<PacJobBookApiBody>;
type DraftStop = Partial<BookingStop>;
type DraftProduct = Partial<PacProduct>;

export function parsePacJobBookingDraft(content: unknown): {
  customer: JobBookingCustomer;
  stops: BookingStop[];
  products: PacProduct[];
} | null {
  if (!isRecord(content) || !Array.isArray(content.stops)) return null;
  const item = content as unknown as DraftContent;

  const customer = parseDraftCustomer(item);

  const stops: BookingStop[] = (item.stops ?? []).map((raw) => {
    const stop = raw as DraftStop;
    return {
      ...parseDraftStopBase(stop),
      start_date: stop.start_date ?? null,
      end_date: stop.end_date ?? null,
      link_dates: stop.link_dates ?? true,
      time_mode: stop.time_mode ?? 'any',
      am_pm: stop.am_pm ?? null,
      time_from: stop.time_from ?? null,
      time_to: stop.time_to ?? null,
    };
  });

  const rawProducts = (item.products ?? []) as DraftProduct[];
  const products: PacProduct[] = rawProducts.length
    ? rawProducts.map((product) => ({
        box_type: product.box_type ?? null,
        product: product.product ?? null,
        weight: product.weight ?? 0,
        quantity: product.quantity ?? 1,
        description: product.description ?? '',
      }))
    : [createEmptyPacProduct()];

  return { customer, stops, products };
}
